import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, ModalController} from '@ionic/angular';
import {MeterReadingDTOModel} from '../../models/meter-reading-DTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {GeneralService} from '../../services/general.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';

@Component({
    selector: 'app-meter-readings',
    templateUrl: './meter-readings.page.html',
    styleUrls: ['./meter-readings.page.scss'],
})
export class MeterReadingsPage implements OnInit {

    @ViewChild('input') input;
    @Input() document: DocumentModel;
    meterReadingTypes: any[];
    mandatoryReadings: any;

    constructor(public modalController: ModalController,
                private alertController: AlertController,
                private loki: LokijsService,
                private generalService: GeneralService,
                private stateManager: StateManagerService,
                private collNames: CollectionsNames) {
    }

    ngOnInit() {
        this.meterReadingTypes = JSON.parse(JSON.stringify(this.stateManager.getCollection(this.collNames.METERTYPE)));
        this.mandatoryReadings = this.stateManager.getCollection(this.collNames.MANDATORYMETERS);
        this.mandatoryReadings = this.mandatoryReadings.filter(reading => {
            return reading.jobType === this.document.serviceJob.jobTypeId && reading.pdesc === this.document.serviceJob.servicedItem.pdesc;
        });
        if (this.document.serviceJob.meterReadings && this.document.serviceJob.meterReadings.length > 0) {
            this.checkMeterReadingPresent();
        }
        this.checkMandatoryReadings();
    }

    checkMeterReadingPresent() {
        console.log(this.document.serviceJob.meterReadings);
        console.log(this.meterReadingTypes);
        for (const mr of this.document.serviceJob.meterReadings) {
            for (const mrt of this.meterReadingTypes) {
                if (mr._id === mrt._id) {
                    mrt.value = mr.value;
                    mrt.isChecked = true;
                }
            }
        }
    }

    private checkMandatoryReadings() {
        if (this.mandatoryReadings.length > 0) {
            for (const mr of this.meterReadingTypes) {
                for (const mandR of this.mandatoryReadings) {
                    if (mr.description === mandR.meterName) {
                        mr.isMandatory = true;
                    }
                }
            }
        }
    }

    addMeterReading() {
        const tempReadings = [];
        for (const reading of this.meterReadingTypes) {
            if (reading.isChecked) {
                delete reading.isChecked;
                delete reading.isMandatory;
                //reading.id = tempReadings.length + 1;
                reading.readingDate = new Date().toISOString();
                tempReadings.push(reading);
            }
        }
        this.document.serviceJob.meterReadings = tempReadings;
        console.log(this.document.serviceJob.meterReadings);
        this.modalController.dismiss();
    }
}
